import { render, staticRenderFns } from "./ai-chat-icon.vue?vue&type=template&id=15bf6682&scoped=true"
import script from "./ai-chat-icon.vue?vue&type=script&lang=js"
export * from "./ai-chat-icon.vue?vue&type=script&lang=js"
import style0 from "./ai-chat-icon.vue?vue&type=style&index=0&id=15bf6682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf6682",
  null
  
)

export default component.exports